import React from "react";
import { IconButton } from "react-native-paper";

export const ChangeImageButton = ({ visible, icon, action }: any) => {
  const iconColor = visible ? "rgba(255,255,255,0.5)" : "transparent";
  return (
    <IconButton icon={icon} size={50} onPress={action} iconColor={iconColor} />
  );
};
